export const MY_DELEGATES = '/my-delegates';
export const MANAGE_USERS = '/manage-users';
export const DRAFT_ORDERS = '/draft-orders';
export const ORDERS_AND_REPORTS = '/requisitions';
export const PATIENTS = '/patients';
